import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS } from "./translations";
import { FIND_TRANSLATIONS } from "./findTranslations";
import { ENGAGE_TRANSLATIONS } from "./engageTranslations";

function deepMerge(a, b) {
    const out = { ...a };
    for (const k of Object.keys(b)) {
        if (b[k] && typeof b[k] === "object" && !Array.isArray(b[k]) && a[k]) {
            out[k] = deepMerge(a[k], b[k]);
        } else {
            out[k] = b[k];
        }
    }
    return out;
}

const MERGED = {
    en: deepMerge(deepMerge(TRANSLATIONS.en, FIND_TRANSLATIONS.en), ENGAGE_TRANSLATIONS.en),
    fr: deepMerge(deepMerge(TRANSLATIONS.fr, FIND_TRANSLATIONS.fr), ENGAGE_TRANSLATIONS.fr),
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [locale, setLocaleState] = useState(() => {
        if (typeof window === "undefined") return "en";
        const stored = localStorage.getItem("boxeb2b_locale");
        if (stored === "en" || stored === "fr") return stored;
        const nav = (navigator.language || "en").toLowerCase();
        return nav.startsWith("fr") ? "fr" : "en";
    });

    const setLocale = useCallback((l) => {
        setLocaleState(l);
        if (typeof window !== "undefined") localStorage.setItem("boxeb2b_locale", l);
    }, []);

    useEffect(() => {
        if (typeof document !== "undefined") document.documentElement.lang = locale;
    }, [locale]);

    const value = useMemo(() => ({
        locale,
        setLocale,
        t: MERGED[locale] || MERGED.en,
        toggle: () => setLocale(locale === "en" ? "fr" : "en"),
    }), [locale, setLocale]);

    return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
    const ctx = useContext(I18nContext);
    if (!ctx) throw new Error("useI18n must be used within I18nProvider");
    return ctx;
}
